<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <!--底部样式-->
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="list">
              <HeaderBar :title="barTitle"></HeaderBar>
              <el-button class="addOnline" size="small" @click="handleAddOnline">新增咨询</el-button>
              <!-- 查询模块 -->
              <div class="query-box">
                <el-form :model="queryForm" :inline="true">
                  <el-form-item>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item>
                          <el-input v-model="queryForm.qaTitle" placeholder="标题" clearable size="medium"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-date-picker
                            style="width: 193px;"
                            type="date"
                            class="dateClass"
                            v-model="createDateStarts"
                            value-format="yyyy-MM-dd"
                            placeholder="提问开始日期" size="medium">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item>
                          <el-date-picker
                            style="width: 193px;"
                            type="date"
                            class="dateClass"
                            v-model="createDateEnds"
                            value-format="yyyy-MM-dd"
                            placeholder="提问开始日期" size="medium">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" style="width: 196px;">
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-col :span="24" style="text-align: right;margin-top: -61px;">
                    <el-form-item>
                      <el-row>
                        <el-button @click="clearInput()" >清空</el-button>
                        <el-button @click="getOnlineList()" class="list-button">查询</el-button>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-form>
              </div>
              <!-- 列表模块 -->
              <div class="list-card">
                <el-table
                  :data="lists"
                  :row-style="rowStyle"
                  :cell-style="cellStyle"
                  :show-header="false"
                  max-height="320px"
                  @row-click="handleRowClickEvent"
                >
                  <el-table-column prop="qaTitle" width="" show-overflow-tooltip align="left">
                  </el-table-column>
                  <el-table-column prop="createDate" width="120" align="right"> </el-table-column>
                </el-table>
                <el-divider></el-divider>
                <el-pagination
                  background
                  @current-change="handleCurrentChangeEvent"
                  :current-page="pageNo"
                  :page-size="pageSize"
                  :total="totalElements"
                  layout="total, prev, pager, next, jumper">
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
    <!-- 新增咨询 -->
    <el-dialog
      title="新增咨询"
      :before-close="handleCancelAddOnline"
      :visible.sync="showAddOnline">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="标题" prop="qaTitle">
          <el-input v-model="form.qaTitle" placeholder="标题" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item prop="qaDesc" label="详细描述">
          <el-input type="textarea" :rows="3" placeholder="详细描述" v-model="form.qaDesc" maxlength="500"></el-input>
        </el-form-item>

        <el-form-item label="联系人" prop="questioner">
          <el-input v-model="form.questioner" placeholder="联系人" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="questionerTelephone">
          <el-input v-model="form.questionerTelephone" placeholder="联系电话"></el-input>
        </el-form-item>

        <el-form-item label="电子邮箱" prop="questionerMail">
          <el-input type="email" v-model="form.questionerMail" placeholder="电子邮箱"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"  class="dialog-footer">
          <el-button @click="handleCancelAddOnline()">取消</el-button>
          <el-button type="primary" @click="saveOnline()">提交</el-button>
       </span>
    </el-dialog>
    <!-- 问题详情 -->
    <el-dialog
      class="details-dialog"
      title="问题详情"
      :close-on-click-modal="false"
      :visible.sync="showDetails">
      <el-form :model="formInfo" label-width="90px">
        <el-form-item label="标题：">
          {{formInfo.qaTitle}}
        </el-form-item>
        <el-form-item label="详细描述：">
          {{formInfo.qaDesc}}
        </el-form-item>
        <el-form-item label="回复内容：">
          {{formInfo.askContent}}
        </el-form-item>
        <el-form-item label="联系人：">
          {{formInfo.questioner}}
        </el-form-item>
        <el-form-item label="联系电话：">
          {{formInfo.questionerTelephone}}
        </el-form-item>
        <el-form-item label="电子邮箱：">
          {{formInfo.questionerMail}}
        </el-form-item>
      </el-form>
      <!--<el-row :gutter="20">
        <el-col :span="4"><label>标题：</label></el-col>
        <el-col :span="20"><div>{{formInfo.qaTitle}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4"><label>详细描述：</label></el-col>
        <el-col :span="20"><div>{{formInfo.qaDesc}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4"><label>回复内容：</label></el-col>
        <el-col :span="20"><div>{{formInfo.askContent}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4"><label>联系人：</label></el-col>
        <el-col :span="20"><div>{{formInfo.questioner}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4"><label>联系电话：</label></el-col>
        <el-col :span="20"><div>{{formInfo.questionerTelephone}}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4"><label>电子邮箱：</label></el-col>
        <el-col :span="20"><div>{{formInfo.questionerMail}}</div></el-col>
      </el-row>-->
      <span slot="footer"  class="dialog-footer">
          <el-button @click="showDetails = false">关闭</el-button>
       </span>
    </el-dialog>
  </el-container>
</template>
              <el-divider></el-divider>

<script>
import * as dayjs from 'dayjs';
import HeaderBar from '@/components/HeaderBar.vue';
import { prefixedUrlAsset } from '@/utils/constants';

export default {
  name: 'OnlineList',
  components: { HeaderBar },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      totalElements: 10,
      createDateStarts: '',
      createDateEnds: '',
      barTitle: '在线咨询',
      lists: [], // 咨询列表数据
      menuType: '',
      queryForm: {
        qaTitle: '',
        createDateStart: null,
        createDateEnd: null,
        isPublic: 0
      },
      form: {
        qaTitle: '',
        qaDesc: '',
        questioner: '',
        questionerTelephone: '',
        questionerMail: '',
        isAnswer: 1,
        isPublic: 1
      }, // 新增form
      showAddOnline: false, // 是否显示新增咨询模态框
      rules: {
        qaTitle: {
          required: true, message: '标题不能为空', trigger: 'blur'
        },
        qaDesc: {
          required: true, message: '详细描述不能为空', trigger: 'blur'
        },
        questioner: {
          required: true, message: '联系人不能为空', trigger: 'blur'
        },
        questionerTelephone: [{
          required: true, message: '请输入正确的电话', trigger: 'blur',
          /*pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/}*/
          pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/}
        ],
        questionerMail: [{
          required: true, message: '请输入邮箱', trigger: 'blur',
        },
        {
          type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']
        }]
      },
      showDetails: false, // 是否显示问题详情
      formInfo: {} // 问题详情form信息
    };
  },
  created() {
    this.getOnlineList();
  },
  methods: {
    cellStyle() {
      return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
    },
    rowStyle() {
      return 'white-space: nowrap;';
    },
    // 修改页数
    handleCurrentChangeEvent(pageNo) {
      console.log(pageNo);
      this.pageNo = pageNo;
      this.getOnlineList();
    },
    // 每条数据的点击事件
    handleRowClickEvent(row) {
      console.log(row);
      this.formInfo = {}
      this.formInfo = JSON.parse(JSON.stringify(row))
      this.showDetails = true
    },
    // 清空
    clearInput() {
      this.queryForm.qaTitle = ''
      this.createDateStarts = ''
      this.createDateEnds = ''
    },
    // 新增咨询按钮
    handleAddOnline() {
      this.showAddOnline = true
    },
    // 关闭新增咨询
    handleCancelAddOnline() {
      this.showAddOnline = false
      this.$refs.form.resetFields()
    },
    // 新增咨询提交
    saveOnline() {
      console.log('1')
      let that = this
      that.$refs['form'].validate(function (valid, rules) {
        if (valid) {
          // 提交方法 返回后的处理 form重置关闭刷新列表 提交成功
          that.axios.post(`${prefixedUrlAsset}/pub/qa/add`, that.form)
            .then((res) => {
              console.log(res)
              if (res.data.code == 0) {
                // 提示成功信息
                that.$notify.success({
                  title: "成功",
                  message: "提交完成"
                });
                // 关闭弹出框且重新查询列表
                that.handleCancelAddOnline()
                that.getOnlineList()
              } else {
                that.$notify.error({
                  title: "错误",
                  message: "请重新尝试"
                });
              }
          })
        }
      });
    },
    // 获取咨询列表
    getOnlineList() {
      this.queryForm.pageNo = this.pageNo-1
      this.queryForm.pageSize = this.pageSize
      // 将开始提问时间时间戳传到后台
      if (this.createDateStarts != '' && this.createDateStarts != null) {
        this.queryForm.createDateStart = new Date(this.createDateStarts+ ' 00:00:00').getTime()
        console.log(new Date(this.createDateStarts + ' 00:00:00').getTime())
      } else {
        this.queryForm.createDateStart = null
      }
      // 将结束提问时间时间戳传到后台
      if (this.createDateEnds != '' && this.createDateEnds != null) {
        this.queryForm.createDateEnd = new Date(this.createDateEnds+ ' 23:59:59').getTime()
        console.log(new Date(this.createDateEnds + ' 23:59:59').getTime())
      } else {
        this.queryForm.createDateEnd = null
      }
      this.axios
        .post(
          `${prefixedUrlAsset}/pub/qa/list`, this.queryForm
        )
        .then((response) => {
          debugger;
          console.log(response.data);
          if (response.data.code == 0) {
            this.pageNo = response.data.data.number + 1;
            this.totalElements = response.data.data.totalElements;
            if (response.data.data.content) {
              this.lists = response.data.data.content.map(item => {
                return {
                  ...item,
                  createDate: item.createDate ? dayjs(item.createDate).format("YYYY-MM-DD") : null,
                  answerDate: item.answerDate ? dayjs(item.answerDate).format("YYYY-MM-DD") : null,
                };
              });
            }
          }
        });
    }
  }
}
</script>

<style lang="scss">
  .list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    padding: 10px 10px 0px 10px;
    margin-bottom: 20px;
    .list-card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px 10px 10px 10px;
      width: 100%;
      background-color: white;
      border-left: 1px solid #DCDCDC;
      border-right: 1px solid #DCDCDC;
      border-bottom: 1px solid #DCDCDC;
      box-sizing: border-box;
      border-radius: 0 0 15px 15px;
      .el-divider--horizontal{
        margin: 12px 0 !important;
      }
    }
    .addOnline{
      position: absolute;
      left: 120px;
      top: 20px;
      background: rgba(255, 255, 255, .3);
      border: 1px solid #ddd;
      margin-left: 12px;
      padding: 9px 12px;
      border-radius: 5px;
    }
    .addOnline:focus, .addOnline:hover{
      color: #606266;
    }
    .query-box{
      width: 100%;
      border-left: 1px solid #DCDCDC;
      border-right: 1px solid #DCDCDC;
      border-bottom: 1px solid #DCDCDC;
      padding: 20px 10px 4px;
      box-sizing: border-box;
      .list-button{
        background: #026D31;
        color: white;
      }
      .list-button:hover{
        background: #DCDCDC;
        color: #026D31;
      }
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #026D31;
    color: #FFF;
  }
  /* 弹出框样式 */
  .el-dialog{
    width: 60%;
    .el-dialog__header{
      .el-dialog__close:focus, .el-dialog__close:hover{
        color: #33CC70;
      }
    }
    .el-dialog__body{
      padding: 30px 20px 0;
    }
    .el-dialog__footer{
      text-align: right;
      padding: 20px;
      .el-button--primary{
        background: #00ab4c;
        border-color: #00ab4c;
      }
      .el-button--primary:focus, .el-button--primary:hover{
        background: #33CC70;
        border-color: #33CC70;
      }
      .el-button--default:focus, .el-button--default:hover{
        background: #fff;
        color: #606266;
        border-color: #DCDFE6;
      }
    }
  }
  /*详情页样式*/
  .details-dialog{
    .el-form-item__label{
      line-height: normal;
      font-weight: bold;
    }
    .el-form-item__content{
      line-height: normal;
    }
  }
</style>
